import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@material-ui/core';
import { polkCloseIcon } from 'assets/newIcons';
import styles from './styles.module.css';

const StatusPopup = ({
  open,
  onClose,
  icon,
  iconAlt,
  badgeText,
  title,
  description,
  items,
  notifyIcon,
  notifyText,
  buttonText,
  onButtonClick,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="status-popup-title"
      maxWidth={false}
      PaperProps={{
        style: {
          borderRadius: '14px',
          margin: '16px',
        },
      }}
    >
      <div className={styles.popupContainer}>
        <button
          type="button"
          className={styles.closeButton}
          onClick={onClose}
          aria-label="close"
        >
          <img src={polkCloseIcon} alt="" className={styles.closeIcon} />
        </button>

        <div className={styles.iconCircle}>
          <img src={icon} alt={iconAlt} className={styles.icon} />
        </div>

        <div className={styles.textWrapper}>
          {badgeText && (
            <div className={styles.badge}>
              <span className={styles.badgeText}>{badgeText}</span>
            </div>
          )}
          <p className={styles.title} id="status-popup-title">
            {title}
          </p>
          {description && <p className={styles.description}>{description}</p>}
        </div>

        {items.length > 0 && (
          <div className={styles.contentWrapper}>
            <div className={styles.itemsWrapper}>
              {items.map((item, index) => (
                <div className={styles.notifyPill} key={index}>
                  {item.icon && (
                    <img src={item.icon} alt="" className={styles.itemIcon} />
                  )}
                  <div className={styles.itemTextColumn}>
                    <p className={styles.itemTitle}>{item.title}</p>
                    <p className={styles.itemDescription}>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {notifyText && (
          <div className={styles.contentWrapper}>
            <div className={styles.notifyPill}>
              {notifyIcon && (
                <img src={notifyIcon} alt="" className={styles.notifyIcon} />
              )}
              <span className={styles.notifyText}>{notifyText}</span>
            </div>
          </div>
        )}

        <div className={styles.contentWrapper}>
          <button className={styles.gotItButton} onClick={onButtonClick || onClose}>
            {buttonText}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

StatusPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  iconAlt: PropTypes.string,
  badgeText: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ),
  notifyIcon: PropTypes.string,
  notifyText: PropTypes.string,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
};

StatusPopup.defaultProps = {
  iconAlt: '',
  badgeText: '',
  description: '',
  items: [],
  notifyIcon: '',
  notifyText: '',
  buttonText: 'GOT IT',
  onButtonClick: null,
};

export default StatusPopup;
